import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Settings } from '../../model/settings.model';
import { RoiService } from '../../service/roi.service';
import { DamageService } from '../../service/damage.service';
import { DamageAnalysis, DamagesGroupedByLocation } from '../../model/damage.model';
import { String } from 'aws-sdk/clients/appstream';

@Component({
  selector: 'app-vehicle-svg',
  templateUrl: './vehicle-svg.component.html',
  styleUrls: ['./vehicle-svg.component.less']
})
export class VehicleSvgComponent implements OnInit, OnChanges {
  @Input() settings: Settings;
  @Input() oneSide: boolean;
  @Input() inPlayer: boolean;
  @Input() damagesGroup: DamagesGroupedByLocation[];
  @Input() activeSection: string;
  @Input() hilightPart: string;
  @Output() editActiveSection = new EventEmitter();

  displayBlueprint: string;

  constructor(private readonly _roiService: RoiService,
    private readonly _damageService: DamageService) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hilightPart) {
      console.log('change part ');
      this.showFace(this.hilightPart)
    }
  }

  newDamagesInPart(partId: String) {
    if (this.hilightPart && this.hilightPart === partId) {
      return true
    }
    if (this.damagesGroup) {
      let index = this.damagesGroup.findIndex(group => { return group.svgLocation === partId })
      if (index !== -1) {
        return this.damagesGroup[index].newDamages
      } else return false
    } else return false
  }


  ngOnInit() {
    if (this.damagesGroup && this.damagesGroup[0] && this.damagesGroup[0].svgLocation)
      this.showFace(this.damagesGroup[0].svgLocation)
    if (this.hilightPart)
      this.showFace(this.hilightPart)
  }

  isDamageSpiedOn(partId: string) {
    return this._roiService.mapToSvgId(this.activeSection) === partId;
  }


  showFace(e: string) {
    if (this.oneSide)
      if (this._damageService.partsInRightTchekSvg.includes(e))
        this.displayBlueprint = 'right';
      else
        this.displayBlueprint = 'left';
    // console.log('displayBlueprint',this._damageService.partsInRightTchekSvg.includes(e), this.displayBlueprint);
  }

  hasDamageInPart(partId: string) {
    if (this.damagesGroup)
      return this.damagesGroup.find(group => {
        const normalizedPart = this._roiService.mapToSvgId(group.location);

        // console.log(normalizedPart, partId);
        if (!group.svgLocation)
          return false;
        else if (normalizedPart === partId)
          return true;
      });
    else
      return false;
  }

  getSeverity(partId: string, severity: string) {
    if (this.damagesGroup)
      return this.damagesGroup.find(group => {
        const normalizedPart = this._roiService.mapToSvgId(group.location);
        if (!group.svgLocation)
          return false;
        else if (normalizedPart === partId)
          return (severity === group.severityPart.severity);
      });
    else
      return false;
  }


  scrollTo(section: string) {
    if (this.oneSide === false && this.hasDamageInPart(section)) {
      $('div.scrollbox').animate({
        scrollTop: $(`div#${section}`)
          .offset().top - $('div.scrollbox')
            .offset().top + $('div.scrollbox')
              .scrollTop()
      }, 600, () => {
        this.activeSection = section
        this.editActiveSection.emit(section)
      })
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/element/vehicle-svg/vehicle-svg.component.ts